import {
  clearSelectedOrg,
  getOrgHeaderValue,
  isStaleLocationError,
  isStaleOrgError,
  readSelectedOrg,
} from "./orgSelection";

const ORG_HEADER = "x-org-id";
const LOCATION_ID_KEY = "selectedLocationId";
const LOCATION_NAME_KEY = "selectedLocationName";

/** Adds x-org-id to an axios request config when an organization is selected. */
export function attachOrgHeader(request) {
  if (!request.headers) request.headers = {};

  const value = getOrgHeaderValue(request.url);
  if (value) {
    request.headers[ORG_HEADER] = value;
  } else {
    // A retried request carries the headers of its first attempt.
    delete request.headers[ORG_HEADER];
  }

  return request;
}

/**
 * When the API reports the stored selection as missing or invalid, forget it
 * and restart, which shows the organization picker.
 *
 * Does nothing when no selection is stored: a super admin who has not picked
 * yet is already looking at the picker, and restarting would loop.
 */
export function handleStaleOrg(status, message, restart) {
  if (!isStaleOrgError(status, message)) return false;
  if (!readSelectedOrg()) return false;

  clearSelectedOrg();
  // The stored location belongs to the organization that was just dropped
  clearStoredLocation();
  restart();
  return true;
}

function readStoredLocation() {
  try {
    const stored = sessionStorage.getItem(LOCATION_ID_KEY);
    return stored && stored !== "-1" ? stored : null;
  } catch {
    return null;
  }
}

function clearStoredLocation() {
  try {
    sessionStorage.removeItem(LOCATION_ID_KEY);
    sessionStorage.removeItem(LOCATION_NAME_KEY);
  } catch {
    /* sessionStorage unavailable */
  }
}

/**
 * A super admin's stored location can belong to an organization they have
 * left. When the API rejects it, fall back to All Locations and restart.
 *
 * Does nothing without a selected organization or a stored location, so other
 * users are not affected and the restart cannot loop.
 */
export function handleStaleLocation(status, message, restart) {
  if (!isStaleLocationError(status, message)) return false;
  if (!readSelectedOrg() || !readStoredLocation()) return false;

  clearStoredLocation();
  restart();
  return true;
}

/** The app uses a HashRouter, so the root is "#/". */
export function restartAtRoot() {
  // replaceState does not fire hashchange, so no page renders and sends
  // requests between this line and the reload
  window.history.replaceState(null, "", "#/");
  window.location.reload();
}
